import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION2: PdfComponent = {
  type: 'section',
  id: 'iars2',
  title: '2. Definitions',
  content: [
    {
      type: 'altText',
      id: 'iar21',
      content: [
        'Definitions used in this Agreement have the same meaning as under the Act and the FCA Handbook, including:',
      ],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 'iars2bullets',
      bulletType: 'dot',
      content: [
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"Act"',
              ': Financial Services and Markets Act 2000, as amended.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"FCA"',
              ': The Financial Conduct Authority or any successor body.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"FCA Rules"',
              ': The Handbook of Rules and Guidance published by the FCA.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"Compliance Officer"',
              ': The individual appointed by the Principal as responsible for FCA compliance.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"Financial Promotion"',
              ': Any invitation or inducement to engage in investment activity.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"Non-real time Financial Promotion"',
              ': Any Financial Promotion not conducted in real time.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"Confidential Information"',
              ': Any confidential business or client information of the Principal or its group.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 'iar22',
            content: [
              '"Group"',
              ': Parent or subsidiary companies related to the Principal.',
            ],
          },
        },
      ],
      prefix: '1',
    },
  ],
};
